export function canUseLocalStorage() {
  return typeof localStorage !== "undefined";
}
